import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import {
  toggleMenu,
} from 'cityads-v3/actions/menu';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import KeyboardArrowLeftOutlinedIcon from '@material-ui/icons/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@material-ui/icons/KeyboardArrowRightOutlined';

import MenuItem from './MenuItem';
import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';

import classes from './Menu.scss';

@withRouter
@connect(state => ({
  docked: state.menu.docked,
  isMobile: state.app.isMobile,
  menu: state.menu.menu,
}))
export default class MenuContentUser extends Component {

  static propTypes = {
    docked: PropTypes.bool,
    isMobile: PropTypes.bool,
  }

  onToggleMenu = (open, docked = false) => () => {
    this.props.dispatch(toggleMenu(open, docked));
  };

  UNSAFE_componentWillReceiveProps(newProps) {
    if (!this.props.isMobile && newProps.isMobile) {
      this.onToggleMenu(false, false)();
    }
  }

  render() {
    const { docked, isMobile, menu } = this.props;
    return (
      <List>

        {!isMobile && <ListItem
          button
          classes={{
            root: classes.menuItemLink
          }}
          onClick={this.onToggleMenu(true, !docked)}
        >
          <ListItemIcon classes={{root: !docked && !isMobile ? classes.menuItemIcon : ''}}>
            {docked ? <KeyboardArrowLeftOutlinedIcon /> : <KeyboardArrowRightOutlinedIcon />}
          </ListItemIcon>
        </ListItem>}

        {menu.map(item => {
          const listItem = <MenuItem key={item.n} {...item} />;

          return docked ? listItem : (
            <Tooltip
              key={item.n}
              isLight
              title={item.t}
              placement="right"
            >
              {listItem}
            </Tooltip>
          );
        })}

      </List>
    );
  }

}
